<template>
  <div class="searchItemTitle">{{ $t('Тип процедуры') }}</div>
  <div>
    <v-checkbox
        class="procedureStepCheckbox"
        v-for="type in procedureTypes"
        :key="type.code"
        v-model="searchParams.types"
        :label="type.name"
        :value="type.code"
        :true-icon="'mdi-check mdi-18px'"
        :false-icon="'voidCheckbox'"
        hide-details
    />
  </div>
</template>

<script>

export default {
  name: 'ProcedureType',
  props: {
    procedureTypes: {
      type: Array,
      required: true,
      default: []
    },
    searchParams: {
      type: Object,
      required: true,
    },
  },
}
</script>
<style scoped>
:deep(.v-input--density-default) {
  --v-input-control-height: auto;
}
:deep(.v-selection-control--density-default) {
  --v-selection-control-size: 30px;
}
:deep(.procedureStepCheckbox .v-label) {
  color: rgb(var(--black-color));
  font-family: var(--primary-font-family-name);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  opacity: 1;
  padding-left: 13px;
}
:deep(.mdi-check.mdi-18px) {
  border-radius: 3px;
  border: 1px solid rgba(var(--black-color), 0.3);
}
:deep(.voidCheckbox) {
  border-radius: 3px;
  border: 1px solid rgba(var(--black-color), 0.3);
  background-color: rgb(var(--white-color));
}
</style>
